/**
 * ENTITY EMAILS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getEntityEmails,
    getEntityEmail,
    printEntityEmail,
    createEntityEmails,
    updateEntityEmails,
    deleteEntityEmails,
} from "Core/entities/config/api.entity_emails";

const state = {
    page: {},
    form: {},
    entity_emails: [],
    entity_email_options: [],
    selectedEntityEmail: {
        entity_emails_id: null,
        company_id: "",
        entity_email_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        entity_email_details: [],
    },
    entity_emails_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_entity_emails: {
        entity_emails_id: {
            name: "entity_emails_id",
            rules: "trim|max_length[15]|integer|valid_email|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        object_ref: {
            name: "object_ref",
            rules: "trim|max_length[10]|required",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        object_id: {
            name: "object_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        email_type: {
            name: "email_type",
            rules: "trim|max_length[45]|valid_email",
            max_len: "45",
            min_len: "",
            default_value: "",
        },
        email_address: {
            name: "email_address",
            rules: "trim|max_length[100]|valid_email",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        prime: {
            name: "prime",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    entity_emails: (state) => {
        return state.entity_emails;
    },
};

// actions
const actions = {
    async fetchEntityEmails({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getEntityEmails({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageEntityEmails", response.data.page);
                }

                if (body.options) {
                    commit("setFePartOptions", response.data.fe_parts);
                    commit("setEntityEmailsOptions", response.data.entity_emails);
                } else {
                    commit("setEntityEmails", response.data.entity_emails);
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchEntityEmail({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getEntityEmail(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedEntityEmail", response.data.entity_email);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printEntityEmail({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printEntityEmail(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveEntityEmail({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["entity_emails_id"] === "undefined" || body["entity_emails_id"] == null || body["entity_emails_id"] == "") {
                delete body["entity_emails_id"];
                response = await createEntityEmails({ body: body, headers: config.headers });
            } else {
                let entity_emails_id = body["entity_emails_id"];
                delete body["entity_emails_id"];
                response = await updateEntityEmails({ body: body, headers: config.headers }, entity_emails_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteEntityEmail({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteEntityEmails(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageEntityEmails(state, page) {
        state.page = page;
    },
    setEntityEmails(state, entity_emails) {
        state.entity_emails = entity_emails;
    },
    setEntityEmailsOptions(state, entity_emails) {
        state.entity_email_options = entity_emails;
    },
    setSelectedEntityEmail(state, entity_email) {
        state.selectedEntityEmail = entity_email;
    },
    resetSelectedEntityEmail(state) {
        for (const key in state.selectedEntityEmail) {
            if (key in state.rules_entity_emails) {
                state.selectedEntityEmail[key] = state.rules_entity_emails[key].default_value == "null" ? null : state.rules_entity_emails[key].default_value;
            }
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
